import React from "react";
import { Route, Switch } from "react-router-dom";
import Loadable from 'react-loadable';

import CircularProgress from "components/CircularProgress";
import Error404 from "../../components/ErrorPages/Error404";

const Dashboard = Loadable({
  loader: () => import('../../containers/Typist/Dashboard'),
  loading: CircularProgress,
});

const ForTyping = Loadable({
  loader: () => import('../../containers/Typist/ForTyping/index'),
  loading: CircularProgress,
});

const Parked = Loadable({
  loader: () => import('../../containers/Typist/Parked/index'),
  loading: CircularProgress,
});

const Submitted = Loadable({
  loader: () => import('../../containers/Typist/Submitted'),
  loading: CircularProgress,
});

const ReportEditor = Loadable({
  loader: () => import('../../containers/Typist/ReportEditor'),
  loading: CircularProgress,
});
const PrivateTemplates = Loadable({
  loader: () => import('../../containers/Templates/index'),
  loading: CircularProgress,
});
const Library = Loadable({
  loader: () => import('../../containers/Library/Dashboard'),
  loading: CircularProgress,
});
const MyLibrary = Loadable({
  loader: () => import('../../containers/Library/MyLibrary/index'),
  loading: CircularProgress,
});
const AllCases = Loadable({
  loader: () => import('../../containers/Library/AllCases/index'),
  loading: CircularProgress,
});
const NewCases = Loadable({
  loader: () => import('../../containers/Library/NewCases/index'),
  loading: CircularProgress,
});

const WorkloadList = Loadable({
  loader: () => import('../../containers/Typist/WorkloadList'),
  loading: CircularProgress,
});


const Typist = ({ match }) => (
  <Switch>
    <Route exact path={`${match.url}/dashboard`} component={Dashboard} />
    <Route exact path={`${match.url}/workload-list`} component={WorkloadList} />
    <Route exact path={`${match.url}/for-typing`} component={ForTyping} />
    <Route exact path={`${match.url}/parked`} component={Parked} />
    <Route exact path={`${match.url}/submitted`} component={Submitted} />
    <Route exact path={`${match.url}/report-editor`} component={ReportEditor} />
    <Route exact path={`${match.url}/private-templates`} component={PrivateTemplates} />
    <Route exact path={`${match.url}/library`} component={Library} />
    <Route exact path={`${match.url}/my-library`} component={MyLibrary} />
    <Route exact path={`${match.url}/all-cases`} component={AllCases} />
    <Route exact path={`${match.url}/new-cases`} component={NewCases} />
    <Route component={() => <Error404 redirectTo="/typist/dashboard" />} />
  </Switch>
);

export default Typist;
